import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import DataTable from "@/admin/DataTable";
import Library from "@/admin/Library";
import AdminResources from "@/admin/Resources";
import { useFetch, PageHeader, Loading, ErrorBox } from "@/admin/ui";

const COLUMNS = [
  { key: "number", label: "Orden", render: (r) => <span className="adm-sub">{r.number}</span> },
  { key: "title", label: "Nombre", render: (r) => <b>{r.title}</b> },
  { key: "lessons", label: "Lecciones", num: true },
  { key: "media", label: "Archivos", num: true },
  { key: "free", label: "Acceso", render: (r) => <span className={`adm-badge ${r.free ? "info" : "warn"}`}>{r.free ? "General" : "Premium"}</span> },
  { key: "active", label: "Estado", render: (r) => <span className={`adm-badge ${r.active ? "ok" : "mute"}`} data-testid={`admin-module-state-${r.id}`}>{r.active ? "Activo" : "Inactivo"}</span> },
  { key: "act", label: "", render: (r) => <Link to={`/admin/contenido/${r.id}`} className="adm-btn sm" data-testid={`admin-module-edit-${r.id}`}>Editar</Link> },
];

const Modules = () => {
  const { data, error } = useFetch("/admin/modules");
  if (error) return <ErrorBox />;
  if (!data) return <Loading />;
  return <DataTable columns={COLUMNS} rows={data} testid="admin-modules-table" emptyText="Todavía no hay módulos." />;
};

export default function AdminContent() {
  return (
    <div data-testid="admin-content">
      <PageHeader title="Contenido" subtitle="Módulos de la Academia, recursos gratuitos y biblioteca de archivos">
        <Link to="/admin/contenido/nuevo" className="adm-btn primary" data-testid="admin-module-create"><Plus size={15} /> Crear módulo</Link>
      </PageHeader>
      <Tabs defaultValue="modulos" className="adm-tabs">
        <TabsList>
          <TabsTrigger value="modulos" data-testid="admin-content-tab-modulos">Módulos</TabsTrigger>
          <TabsTrigger value="recursos" data-testid="admin-content-tab-recursos">Recursos</TabsTrigger>
          <TabsTrigger value="biblioteca" data-testid="admin-content-tab-biblioteca">Biblioteca</TabsTrigger>
        </TabsList>
        <TabsContent value="modulos" className="mt-4"><Modules /></TabsContent>
        <TabsContent value="recursos" className="mt-4"><AdminResources /></TabsContent>
        <TabsContent value="biblioteca" className="mt-4"><Library /></TabsContent>
      </Tabs>
    </div>
  );
}
